import DropdownItem from '../dropdown/dropdown-item.vue'

/* istanbul ignore next */
DropdownItem.install = function (Vue) {
  Vue.component(DropdownItem.name, DropdownItem)
}

export default DropdownItem
